import { render, staticRenderFns } from "./approved-plant.vue?vue&type=template&id=20b5f8b7&scoped=true&"
import script from "./approved-plant.vue?vue&type=script&lang=js&"
export * from "./approved-plant.vue?vue&type=script&lang=js&"
import style0 from "./approved-plant.vue?vue&type=style&index=0&id=20b5f8b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5f8b7",
  null
  
)

export default component.exports